import React from 'react';
import { useTranslation } from 'react-i18next';

import { Link } from 'react-router-dom';

import EleventhHourLogo from '../assets/11thHourLogo.svg';
import SLI_Logo from '../assets/Logo.svg';
import UC_RGPO_Logo from '../assets/UC-RGPO_logo.jpg';
import { ROUTES } from '../constants/routes';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="h-[2rem] w-auto bg-[#44753E]"></div>
      <div className="mx-auto py-12 md:py-12 px-2 grid lg:grid-cols-3 gap-2 bg-[#44753E] text-[#FFFAF8]">
        <div>
          <img
            className="w-[100px] mx-auto my-0 md:my-2"
            src={SLI_Logo}
            alt={t('footer.logoAlt')}
          />
        </div>
        <div className="lg:col-span-2 flex gap-5 justify-evenly mt-2 md:text-end">
          <div>
            <ul>
              <Link to={ROUTES.HOME}>
                <li className="font-medium">{t('footer.nav.home')}</li>
              </Link>
              <Link to={ROUTES.ABOUT_FARMOS_CP}>
                <li className="font-medium">{t('footer.nav.aboutFarmOsCp')}</li>
              </Link>
              <Link to={ROUTES.ABOUT_US}>
                <li className="font-medium">{t('footer.nav.aboutUs')}</li>
              </Link>
            </ul>
          </div>
          <div>
            <ul>
              <Link to="https://www.ucop.edu/research-grants-program/index.html" target="_blank">
                <li className="font-medium text-left md:text-center max-w-[30vw]">
                  {t('footer.ucSupport')}
                </li>
              </Link>
            </ul>
            <div className="flex items-center justify-center gap-4 my-4">
              <img className="h-[50.4px] w-auto" src={UC_RGPO_Logo} alt={t('footer.ucLogoAlt')} />
              <img
                className="h-[50.4px] w-auto"
                src={EleventhHourLogo}
                alt={t('footer.eleventhHourLogoAlt')}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export { Footer };
